import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FeedbackEmotionScale5 = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M23 18C22.61 18 22.273 18.224 22.108 18.549C22.108 18.549 20.289 22 16 22C11.72 22 9.892 18.55 9.892 18.55C9.727 18.224 9.39 18 9 18C8.448 18 8 18.448 8 19C8 19.161 8.039 19.312 8.106 19.447C8.106 19.447 8.123 19.481 8.127 19.488C8.369 19.929 10.746 24 15.999 24C21.252 24 23.629 19.929 23.871 19.488C23.875 19.48 23.892 19.447 23.892 19.447C23.959 19.312 23.998 19.161 23.998 19C23.998 18.448 23.55 18 22.998 18H23Z" />
		<path d="M23 14C22.448 14 22 13.552 22 13C22 12.448 21.551 12 21 12C20.449 12 20 12.449 20 13C20 13.552 19.552 14 19 14C18.448 14 18 13.552 18 13C18 11.346 19.346 10 21 10C22.654 10 24 11.346 24 13C24 13.552 23.552 14 23 14Z" />
		<path d="M13 14C12.448 14 12 13.552 12 13C12 12.448 11.551 12 11 12C10.449 12 10 12.449 10 13C10 13.552 9.552 14 9 14C8.448 14 8 13.552 8 13C8 11.346 9.346 10 11 10C12.654 10 14 11.346 14 13C14 13.552 13.552 14 13 14Z" />
	</svg>
);

export default FeedbackEmotionScale5;
